import { useLoadBoardServicesQuery } from '../queries/useLoadBoardServicesQuery';

import { createMutationHook } from '~/shared/providers/api';

export const useDeleteRouteMutation = createMutationHook(
  'transportation.routeDelete',
  (params: { id: string }) => ({
    transportationRouteDelete: {
      __args: {
        id: params.id,
      },
    },
  }),
  {
    invalidateQueries: [useLoadBoardServicesQuery],
  },
);
